import { useEffect } from 'react';
import { TourProvider, useTour } from '@reactour/tour';
import '@reactour/tour/dist/index.css';
import { candidaturaTourSteps } from './candidaturaTourSteps';

const STORAGE_KEY = 'mangitalia_candidatura_tour_done';

function TourAutoStart({ step }) {
  const { setIsOpen, setCurrentStep } = useTour();

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => {
      setCurrentStep(0);
      setIsOpen(true);
      localStorage.setItem(STORAGE_KEY, '1');
    }, 800);
    return () => clearTimeout(timer);
  }, [setIsOpen, setCurrentStep]);

  useEffect(() => {
    const stepIndexMap = { 1: 2, 2: 4, 3: 5, 4: 6 };
    if (stepIndexMap[step] !== undefined) {
      setCurrentStep(stepIndexMap[step]);
    }
  }, [step, setCurrentStep]);

  return null;
}

export function CandidaturaTourButton() {
  const { setIsOpen, setCurrentStep } = useTour();

  return (
    <button
      type="button"
      onClick={() => {
        setCurrentStep(0);
        setIsOpen(true);
      }}
      className="bg-white/90 text-[#c78244] px-3 py-2 rounded-lg text-sm font-semibold shadow border border-[#f3deb8]"
      title="Guida passo passo"
    >
      ? Tutorial
    </button>
  );
}

export default function CandidaturaTour({ children, step }) {
  return (
    <TourProvider
      steps={candidaturaTourSteps}
      styles={{
        popover: (base) => ({
          ...base,
          borderRadius: 12,
          padding: 16,
          maxWidth: 340,
        }),
        maskArea: (base) => ({ ...base, rx: 8 }),
        badge: (base) => ({
          ...base,
          background: '#c78244',
        }),
      }}
      padding={{ mask: 8 }}
      scrollSmooth
      showNavigation
      showBadge
      prevButton={({ Button, ...rest }) => (
        <Button {...rest} style={{ ...rest.style, color: '#c78244' }}>
          Indietro
        </Button>
      )}
      nextButton={({ Button, ...rest }) => (
        <Button {...rest} style={{ ...rest.style, background: '#c78244', color: '#fff', borderRadius: 8, padding: '4px 12px' }}>
          Avanti
        </Button>
      )}
    >
      <TourAutoStart step={step} />
      {children}
    </TourProvider>
  );
}
